import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import {HelpersService} from "../../../services/tools/helpers.service";
import { CuentasPorPagarService } from '../../../services/cuentas-por-pagar.service';
@Component({
  selector: 'app-modal-eliminar-cxc',
  templateUrl: './modal-eliminar-cxc.component.html',
  styleUrls: ['./modal-eliminar-cxc.component.scss']
})
export class ModalEliminarCxcComponent implements OnInit {

  
  public modal: any = null;
  public errors: any = {};

  //Modelos
  public cuentaPorCobrar: any = {};

  //Helpers
  public eliminando: boolean = null;

  @ViewChild('modalEliminarCXC')  private content: TemplateRef<any>;
  @Output() public cuentaEliminada : EventEmitter<void> = new EventEmitter

  constructor(public cuentas_por_cobrar_service:CuentasPorCobrarService, 
    private modalService: NgbModal,
    private helperService: HelpersService) { }

  ngOnInit() {
  }


  public openModal(cuentaPorCobrar: any){
    
    this.modal = this.modalService.open(this.content, { });
   
    this.cuentaPorCobrar = cuentaPorCobrar;
    console.log(cuentaPorCobrar);
  }


  public closeModal() {
    this.modal.close();
  }
  public eliminarCuenta() {
    this.eliminando = true;

    this.cuentas_por_cobrar_service.eliminarCuentaPorCobrar(this.cuentaPorCobrar.id_cuenta_por_cobrar).subscribe(
      (response) => {
        console.log(response);
        this.eliminando = false;
        this.cuentaEliminada.emit();
        this.modal.close();

        this.helperService.notification('Cuenta eliminada', 'Se ha eliminado exitosamente la cuenta por cobrar', 'success');

      }, error => {
      this.eliminando = false;
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);
      if (error.status == 400) {
        alert("ERROR: " + JSON.stringify(error));
      }
    }
    );
   }
}



// WEBPACK FOOTER //
// ./src/app/components/reporte-cxc/modal-eliminar-cxc/modal-eliminar-cxc.component.ts